import styled from 'styled-components'

export const ActionItem = styled.div<{ $disabled?: boolean }>`
  padding: 10px 16px;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.2s ease;
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};

  &:hover {
    background-color: ${({ theme, $disabled }) =>
      $disabled ? 'transparent' : theme?.lockedGray5};
  }

  &:active {
    background-color: ${({ theme, $disabled }) =>
      $disabled ? 'transparent' : theme?.lockedGray4};
  }
`

export const ActionLabel = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme?.lockedGray1};
  font-weight: 400;
`
